var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 1.66663C5.40964 1.66663 1.66797 5.40829 1.66797 9.99996C1.66797 14.5916 5.40964 18.3333 10.0013 18.3333C14.593 18.3333 18.3346 14.5916 18.3346 9.99996C18.3346 5.40829 14.593 1.66663 10.0013 1.66663ZM13.9846 8.08329L9.25964 12.8083C9.14297 12.925 8.98464 12.9916 8.81797 12.9916C8.6513 12.9916 8.49297 12.925 8.3763 12.8083L6.01797 10.45C5.7763 10.2083 5.7763 9.80829 6.01797 9.56663C6.25964 9.32496 6.65964 9.32496 6.9013 9.56663L8.81797 11.4833L13.1013 7.19996C13.343 6.95829 13.743 6.95829 13.9846 7.19996C14.2263 7.44163 14.2263 7.83329 13.9846 8.08329Z",
    fill: "#50C878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.eba732c557c05a939b8bb7c8874eda9b.svg";
export { ForwardRef as ReactComponent };